<template>
  <div>
    <!-- 篩選 -->
    <div class="card filter-card">
      <div class="card-body">
        <div class="filter-toggle-icon" @click="toggleFilter">
          <i :class="filterVisible ? 'fa fa-times' : 'fa fa-search'"></i>
        </div>
        <div v-if="filterVisible">
          <div class="row input-row">
            <div class="col-xxl-2 col-6">
              <label for="driver-name">Driver name</label>
              <input type="text" id="driver-name" class="form-control" v-model="filters.driverName" />
            </div>
            <div class="col-xxl-2 col-6">
              <label for="driver-id">Driver ID</label>
              <input type="text" id="driver-id" class="form-control" v-model="filters.driverId" />
            </div>
            <div class="col-xxl-2 col-6">
              <label for="from-date">From</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.fromDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-xxl-2 col-6">
              <label for="to-date">To</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.toDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-xxl-2 col-12 mt-4 d-flex">
              <button class="btn btn-reset" @click="resetFilters">Reset</button>
              <button class="btn btn-search ms-3" @click="fetchFeesAndRefunds()">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 切換 -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" :class="{ active: currentType === 'fee' }" @click="setActiveTab('fee')">Fees</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ active: currentType === 'chargeback' }" @click="setActiveTab('chargeback')">Chargebacks</a>
      </li>
    </ul>

    <!-- DataTable -->
    <div class="card" v-if="paginatedData != ''">
      <div class="card-body">
        <div class="table-responsive signal-table">
          <table class="table table-hover">
            <thead>
              <tr>
                <th 
                  @click="sortTable('created_at')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'created_at'}">
                  <span>Created &nbsp;</span>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col" class="col-charge-to">Charge to</th>
                <th 
                  @click="sortTable('description')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'description'}">
                  <span>Description &nbsp;</span>
                  <i v-if="filters.sort_by === 'description' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'description' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('amount')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'amount'}">
                  <span>Amount &nbsp;</span>
                  <i v-if="filters.sort_by === 'amount' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'amount' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('paid')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'paid'}">
                  <span>Paid &nbsp;</span>
                  <i v-if="filters.sort_by === 'paid' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'paid' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('paid_by')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'paid_by'}">
                  <span>Paid by &nbsp;</span>
                  <i v-if="filters.sort_by === 'paid_by' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'paid_by' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('payment_date')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'payment_date'}">
                  <span>Payment date &nbsp;</span>
                  <i v-if="filters.sort_by === 'payment_date' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'payment_date' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('settlement_ref')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'settlement_ref'}">
                  <span>Payment ref &nbsp;</span>
                  <i v-if="filters.sort_by === 'settlement_ref' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'settlement_ref' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col" class="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td>{{ item.created_at }}</td>
                <td>{{ item.charge_to }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.amount }}</td>
                <td>
                  <i :class="item.paid ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                </td>
                <td>{{ item.paid_by }}</td>
                <td>{{ item.payment_date }}</td>
                <td>{{ item.payment_ref }}</td>
                <td>
                  <EditFeeCharge :item="item" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分頁 -->
        <div class="pagination-wrapper">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>
              Page
                            <input type="number" style="width: 60px;" v-model.number="currentPageInput" @change="changePage(currentPageInput)" />

              of {{ totalPages }}
            </span>
            <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(totalPages)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
          </div>
          <div class="total-count">
            Displaying {{ (currentPage - 1) * itemsPerPage + 1 }} – {{ Math.min(currentPage * itemsPerPage, totalEntries) }} of {{ totalEntries }}
          </div>
        </div> 
      </div>
    </div>
    <div v-else class="no-results">No results found.</div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useFeeAndRefundStore } from '@/store/admin/feeAndRefund'; // 替換為你的 store 路徑
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import EditFeeCharge from './editFeeCharge.vue';

const store = useFeeAndRefundStore();
const { fetchFeesAndRefunds, resetFilters } = store;

const filterVisible = ref(false); // 控制查詢器是否顯示，預設為收起
const currentPageInput = ref(store.currentPage);  // 初始化當前頁碼輸入框

// 表格排序處理邏輯
const sortTable = (field) => {
  if (store.filters.sort_by === field) {
    store.filters.order = store.filters.order === 'asc' ? 'desc' : 'asc';
  } else {
    store.filters.sort_by = field;
    store.filters.order = 'desc';
  }
  fetchFeesAndRefunds(store.currentType);
};

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const setActiveTab = async (type) => {
  store.filters.sort_by = 'created_at';
  store.filters.order = 'desc';
  store.currentType = type;
  await fetchFeesAndRefunds(type); // 傳入類型來獲取數據
};

const filters = computed(() => store.filters);
const currentType = computed(() => store.currentType);
const paginatedData = computed(() => store.paginatedData);
const totalPages = computed(() => store.totalPages);
const totalEntries = computed(() => store.totalEntries);
const currentPage = computed(() => store.currentPage);
const itemsPerPage = computed(() => store.itemsPerPage);

const changePage = (page) => {
    if (page >= 1 && page <= totalPages.value) {
      store.changePage(page); // 改變頁面
    }
  };

onMounted(() => {
  store.filters.sort_by = 'created_at';
  store.filters.order = 'desc';
  store.currentType = 'fee';
  fetchFeesAndRefunds('fee'); // 組件加載時根據當前類型獲取數據
  changePage(1);
});


</script>

<style scoped>
.card {
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  position: relative;
}

  .no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }

.table-responsive {
  margin-top: 10px;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.col-description {
  min-width: 200px;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
}

.pagination-container {
  display: flex;
  align-items: center;
}

.pagination-container button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
}

.pagination-container span {
  margin: 0 10px;
}

.pagination-container input {
  width: 50px;
  text-align: center;
}

.total-count {
  font-size: 16px;
  color: #666;
}
.btn-reset {
  /* BTN_B */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 32px;
  gap: 10px;

  width: 150px;
  height: 46px;

  /* Green */
  border: 2px solid #00C962;
  border-radius: 30px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;


}

.btn-search {
  /* BTN_A_V2 */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 32px;
  gap: 10px;

  width: 150px;
  height: 46px;

  /* Green */
  background: #00C962;
  border-radius: 30px;

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;

}

.btn-reset:hover {
    background: white;
    border: 2px solid #00b452;
  }
  .btn-search:hover {
    background: #00b452;
    border: 2px solid #00b452;
  }

.btn-green {
  margin-top: 20px;
  background-color: #00c962;
  height: 40px;
}

.filter-toggle-icon {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 24px;
  color: #666;
  cursor: pointer;
}

.filter-header {
  display: flex;
  justify-content: flex-end;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link.active {
  border-color: #ddd #ddd #fff;
  background-color: #fff;
  color: #000;
}

.signal-table.table-responsive .table tbody tr td:nth-child(n+1) {
  min-width: 140px !important;
}

.table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}

@media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
